<template>
    <div class="instagram">
        <div class="content">
            <h3>Hanniel día a día</h3>
            <div id="instafeed"></div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            var feed = new Instafeed({
                accessToken: process.env.TOKEN_INSTAGRAM,
                limit: 8,
                template: '<a href="{{link}}" target="_blank"><img title="{{caption}}" src="{{image}}" /></a>'
            });
            feed.run();
        }
    }
</script>

<style scoped>
    h3{
        margin-bottom: 40px!important;
        text-align: center;
        text-transform: none;
    }
    .instagram{
        padding-bottom: 100px;
    }

    @media screen and (max-width: 767px){
        .instagram{
            padding-bottom: 80px;
        }
    }
</style>
<style>
    .instagram #instafeed {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-column-gap: 0.5rem;
        grid-row-gap: 0.5rem;
    }

    .instagram #instafeed a {
        display: flex;
        align-items: center;
        background-color: #EC4802;
    }

    .instagram #instafeed img {
        display: block;
        width: 100%;
    }
    @media screen and (max-width: 767px){
        .instagram #instafeed {
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(4, 1fr);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Instagram.vue